// removed by extract-text-webpack-plugin
module.exports = {"Box":"_fEh6x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelTuple/TupleBoxRight/TupleBoxRight.scss
// module id = 896
// module chunks = 0